import type { ArtworkModel, CampaignModel } from '@models/types'

import CreateArtwork from './CreateArtwork'
import EditArtwork from './EditArtwork'

const featureKeys = [
  'artwork.create',
  'artwork.edit',
] as const

interface ArtworkProps {
  boxProps?: object,
  enabledFeatureKeys: typeof featureKeys[number],
  itemPayload: {
    artwork?: ArtworkModel,
    callbacks: {
      artworkBuilderSelectionModal?: VoidFunction,
      createArtwork?: VoidFunction,
      showUploadArtworkModal?: VoidFunction,
    },
    campaign: CampaignModel,
  },
  redirectUrl?: string,
}

const Artwork = (props: ArtworkProps) => {
  const {
    boxProps,
    enabledFeatureKeys,
    itemPayload,
    itemPayload: {
      artwork,
    },
    redirectUrl,
  } = props

  // Pending Artwork
  if (artwork?.id && (!enabledFeatureKeys || enabledFeatureKeys.includes('artwork.edit'))){
    return (
      <EditArtwork
        itemPayload={itemPayload}
        redirectUrl={redirectUrl}
        {...boxProps}
      />
    )
  }

  // No Artwork
  if (!enabledFeatureKeys || enabledFeatureKeys.includes('artwork.create')){
    return (
      <CreateArtwork
        itemPayload={itemPayload}
        redirectUrl={redirectUrl}
        {...boxProps}
      />
    )
  }

  return null
}

export default Artwork
